<template>
    <div class="switchVoucherRedeem">
        <label
            class="switchVoucherRedeem-checkbox"
            v-bind:class="{ _disabled: disabled }"
        >
            <input
                type="checkbox"
                class="switchVoucherRedeem-hiddenInput"
                v-bind:checked="isRedeemVoucher"
                v-bind:class="voucherToggleGaClass"
                v-bind:disabled="disabled"
                v-on:change="toggleRedeemVoucher()"
            />
            <span
                class="switchVoucherRedeem-checkbox-style"
                v-bind:class="{ _checked: isRedeemVoucher }"
            />
            {{ i18n.t('switchVoucherRedeem') }}
        </label>
        <span class="switchVoucherRedeem-tip" v-on:click="handleClickTip()">
            <SboIcon
                name="system:infoCircle"
                size="16"
                v-bind:class="voucherInfoGaClass"
            />
            <span
                v-if="isShowTip"
                class="switchVoucherRedeem-tip-arrow"
            />
        </span>
        <Transition name="fade-out">
            <div
                v-if="isShowTip"
                class="switchVoucherRedeem-tip-content SingleSlip_Voucher_View_Info"
            >
                <p>{{ i18n.t('switchVoucherRedeem_introduction') }}</p>
                <p>{{ i18n.t('switchVoucherRedeem_setting') }} :</p>
                <p>
                    <SboIcon
                        name="system:user"
                        size="16"
                    />
                    <span>{{ i18n.t('switchVoucherRedeem_setting_location') }}</span>
                </p>
            </div>
        </Transition>
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import SboIcon from '@/components/common/SboIcon.vue';
    import { useApp } from '@/libraries/composables/useApp';
    import { usePlatformActions } from '@/libraries/composables/usePlatformActions';
    import useState from '@/libraries/composables/useState';
    import { i18n } from '@/libraries/i18n';

    const props = withDefaults(defineProps<{
        isRedeemVoucher?: boolean;
        disabled?: boolean;
        gaClassPrefix: string;
    }>(), {
        isRedeemVoucher: false,
        disabled: false,
    });

    const emit = defineEmits<{
        toggleRedeemVoucher: [isRedeemVoucher: boolean];
    }>();

    const [isShowTip, setIsShowTip] = useState(false);
    const voucherToggleGaClass = computed(() => ({
        [`${props.gaClassPrefix}_CheckBox_Voucher_On`]: !props.isRedeemVoucher,
        [`${props.gaClassPrefix}_CheckBox_Voucher_Off`]: props.isRedeemVoucher,
    }));
    const voucherInfoGaClass = computed(() => `${props.gaClassPrefix}_Voucher_Btn_Info`);

    function toggleRedeemVoucher() {
        emit('toggleRedeemVoucher', !props.isRedeemVoucher);
    }

    const { goToVoucherPageInApp } = useApp();
    const { handleActionByPlatform } = usePlatformActions();
    function handleClickTip() {
        handleActionByPlatform({
            appAction: () => goToVoucherPageInApp(),
            webAction: () => setIsShowTip(!isShowTip.value),
        });
    }
</script>

<style lang="scss" scoped>
    @import "@/scss/components/switchVoucherRedeem";
</style>
